import { render } from "./AppDownload.vue?vue&type=template&id=3fdf33d0&scoped=true&ts=true"
import script from "./AppDownload.vue?vue&type=script&lang=ts"
export * from "./AppDownload.vue?vue&type=script&lang=ts"

import "./AppDownload.vue?vue&type=style&index=0&id=3fdf33d0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdf33d0"]])

export default __exports__